/*@ngInject*/
const FormInstanceRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getFormInstanceById = function (formId) {
        let url = '/rest/Form/' + formId + '/List';

        return this.get(url);
    };

    this.processGetResponseData = function (responseData) {
        return responseData.formSummaries[0];
    };
};

angular.module('umFormViewer')
    .service('formInstanceRepository', FormInstanceRepository);
